// Store locator with customisations
// - custom marker
// - custom info window (using Info Bubble)
// - custom info window content (+ store hours)

document.addEventListener('DOMContentLoaded', function(){

  const marker_image = '//cdn.shopify.com/s/files/1/0065/4616/1748/files/map-pin.png?22502';
  const store_data_url = '/pages/store-locator-data';
  // const store_data_url = '/pages/find-a-branch-list?view=storesdev';
  
  var ICON = new google.maps.MarkerImage(marker_image, null, null, new google.maps.Point(14, 13));
  let defaultZoom = 5.5;
  
  google.maps.event.addDomListener(window, 'load', function() {
    var map = new google.maps.Map(document.getElementById('map-canvas'), {
      center: new google.maps.LatLng(defaultLatLong[0], defaultLatLong[1]),
      zoom: defaultZoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [{
        stylers: [{
          saturation: -100
        }]
      }]
    });
  
  var data = new MedicareDataSource(store_data_url);
  
  var panelDiv = document.getElementById('panel');
  
  var view = new storeLocator.View(map, data, {
    geolocation: true,
  });
  
  view.createMarker = function (store) {
    var markerOptions = {
      position: store.getLocation(),
      icon: ICON,
      title: store.getDetails().title
    };
    return new google.maps.Marker(markerOptions);
  }
  
  var infoBubble = new InfoBubble;
  view.getInfoWindow = function (store) {
    if (!store) {
      return infoBubble;
    }
  
    var details = store.getDetails();
  
    var html = ['<div class="store"><div class="title">', details.title,
      '</div><div class="address">', details.address, '</div>',
      '</div>'].join('');
  
    infoBubble.setContent($(html)[0]);
    return infoBubble;
  };
  
  new storeLocator.Panel(panelDiv, {
    view: view
  });
  
  });
  
  /**
   * Reads store location data from a JSON source
   * @extends storeLocator.StaticDataFeed
   * @param {string} store_data
   * @constructor
   */
  
  function MedicareDataSource(store_data) {
    $.extend(this, new storeLocator.StaticDataFeed);
    let that = this;
    $.get(store_data, function(data) {
      that.setStores(that.parse_(data));
    });
  }
  
  /**
   * @const
   * @type {!storeLocator.FeatureSet}
   * @private
   */
  MedicareDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
  
  );
  
  
  /**
   * @return {!storeLocator.FeatureSet}
   */
  MedicareDataSource.prototype.getFeatures = function() {
    return this.FEATURES_;
  };
  /**
   * @private
   * @param {string} csv
   * @return {!Array.<!storeLocator.Store>}
   */
   MedicareDataSource.prototype.parse_ = function(json) {
    var stores = [];
  
    let jsonRows = JSON.parse(json);
    for (var i = 0, row; row = jsonRows[i]; i++) {
  
      var features = new storeLocator.FeatureSet;
      var position = new google.maps.LatLng(row.ycoord, row.xcoord);
      var locality = '<div class="addr">' + this.join_([row.street_add, row.unit_bldg, row.locality], '<br>') + '</div>';
  
      if( row.operating_hours != '' && row.operating_hours != ' ' ){
        locality += `<div class="hours">Hours of Operation: ${row.operating_hours}</div>`;
      }
  
      var numbers = [];
      if( row.toll_free ){
        numbers.push( '<div class="tel">Toll-free: <a href="tel:'+ row.toll_free +'">'+ row.toll_free +'</a></div>' );
      }
  
      if( row.phone_number ){
        numbers.push( '<div class="tel">Phone: <a href="tel:'+ row.phone_number +'">'+ row.phone_number +'</a></div>' );
      }

      let mapButtons = `<a href="${row.location_url}">More Details &rsaquo;</a>`;
  
      if( row.gmaps_url ){
        mapButtons = `<a href="${row.gmaps_url}" class="d-btn" target="_blank" rel="noopener noreferrer">Get Directions</a>` + mapButtons;
      }
  
      // numbers.push( `<div class="map-btns">${mapButtons}</div>` );
  
      var locationName = row.location_name;
      var store = new storeLocator.Store(row.uuid, position, features, {
        title: locationName,
        address: this.join_([locality, numbers.join('')], ''),
      }, locationName );
  
      stores.push(store);
      
    }
    return stores;
  };
  
  /**
   * Joins elements of an array that are non-empty and non-null.
   * @private
   * @param {!Array} arr array of elements to join.
   * @param {string} sep the separator.
   * @return {string}
   */
  MedicareDataSource.prototype.join_ = function(arr, sep) {
    var parts = [];
    for (var i = 0, ii = arr.length; i < ii; i++) {
      arr[i] && parts.push(arr[i]);
    }
    return parts.join(sep);
  };
  
  /**
   * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
   * IMPORTANT: Don't use this for general CSV parsing!
   * @private
   * @param {string} row
   * @return {Array.<string>}
   */
  MedicareDataSource.prototype.parseRow_ = function(row) {
    // Strip leading quote.
    if (row.charAt(0) == '"') {
      row = row.substring(1);
    }
    // Strip trailing quote. There seems to be a character between the last quote
    // and the line ending, hence 2 instead of 1.
    if (row.charAt(row.length - 1) == '"') {
      row = row.substring(0, row.length - 1);
    }
  
    row = row.split('","');
  
    return row;
  
  };
  
  /**
   * Creates an object mapping headings to row elements.
   * @private
   * @param {Array.<string>} headings
   * @param {Array.<string>} row
   * @return {Object}
   */
  MedicareDataSource.prototype.toObject_ = function(headings, row) {
    var result = {};
    for (var i = 0, ii = row.length; i < ii; i++) {
      result[headings[i]] = row[i];
    }
    return result;
  
  };
  
  });
  